import React, { useState } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import styles from './SupportTicketModals.module.css';
import iconClose from '../../../images/icon-close.svg';
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/rootReducer";
import { updateSupportTicketStatus } from "../../../redux/support-ticket/actions/support-ticket.action";
import Loader from '../../common/loader/Loader';

export interface SupportTicketFormData {
    description: string;
}

export type TicketActionType = "close" | "reopen";

interface SupportTicketActionModalProps {
    title: string;
    buttonText: string;
    actionType: TicketActionType;
    ticketId: string;
    onClose: () => void;
    setShowToast: (show: boolean) => void;
    setToastType: (type: string) => void;
    setToastMessage: (message: string) => void;
}

export const SupportTicketActionModal = ({
    title,
    buttonText,
    actionType,
    ticketId,
    onClose,
    setShowToast,
    setToastType,
    setToastMessage
}: SupportTicketActionModalProps) => {

    const dispatch = useDispatch<AppDispatch>();

    const [loading, setLoading] = useState(false);
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm<SupportTicketFormData>({
        defaultValues: {
            description: ''
        }
    });

    const editSupportTicketSuccess = (message: string) => {
        if (setShowToast && setToastType && setToastMessage) {
            setShowToast(true);
            setToastType('success');
            setToastMessage(message);
        }
    };

    const editSupportTicketFailure = (message: string) => {
        if (setShowToast && setToastType && setToastMessage) {
            setShowToast(true);
            setToastType('error');
            setToastMessage(message);
        }
    };
    const onSubmit: SubmitHandler<SupportTicketFormData> = async (data) => {
        try {
            setLoading(true);
            const ticketStatus =
                actionType === "close"
                    ? "closed"
                    : "re_open";
            if (ticketId) {
                await dispatch(updateSupportTicketStatus(ticketId, ticketStatus, data.description, editSupportTicketSuccess, editSupportTicketFailure));
                reset();
                onClose();
            }
        } catch (error) {
            setToastMessage?.('Something went wrong');
            setShowToast?.(true);
            setToastType?.('error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.modalContent}>
            {(loading) && <Loader />}
            <div className={styles.modalHeader}>
                <h2>{title}</h2>
                <div className={styles.closeIcon} onClick={onClose}>
                    <img src={iconClose} alt="close" />
                </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={styles.modalBody}>
                    <label>Description</label>
                    <Controller
                        name="description"
                        control={control}
                        rules={{ required: "Description is required" }}
                        render={({ field }) => (
                            <textarea
                                {...field}
                                className={styles.textareaField}
                                placeholder="Enter description"
                            />
                        )}
                    />
                    {errors.description && (
                        <span className={styles.errorMessage}>
                            {errors.description.message}
                        </span>
                    )}
                </div>

                <div className={styles.modalFooter}>
                    <button
                        type="submit"
                        className={styles.submitBtn}
                    >
                        {buttonText}
                    </button>
                </div>
            </form>
        </div>
    );
};